/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_ThunderstormInputs */

const en_ui_weather_thunderstorm = /** @type {(inputs: Ui_Weather_ThunderstormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thunderstorm`)
};

const de_ui_weather_thunderstorm = /** @type {(inputs: Ui_Weather_ThunderstormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewitter`)
};

/**
* | output |
* | --- |
* | "Thunderstorm" |
*
* @param {Ui_Weather_ThunderstormInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_thunderstorm = /** @type {((inputs?: Ui_Weather_ThunderstormInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_ThunderstormInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_thunderstorm(inputs)
	return de_ui_weather_thunderstorm(inputs)
});